import { render, staticRenderFns } from "./_general-report.tab.vue?vue&type=template&id=43a9a9e8&scoped=true"
import script from "./_general-report.tab.vue?vue&type=script&lang=js"
export * from "./_general-report.tab.vue?vue&type=script&lang=js"
import style0 from "./_general-report.tab.vue?vue&type=style&index=0&id=43a9a9e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a9a9e8",
  null
  
)

export default component.exports